import { render, staticRenderFns } from "./subdeal.vue?vue&type=template&id=022d4f2c&scoped=true&"
import script from "./subdeal.vue?vue&type=script&lang=js&"
export * from "./subdeal.vue?vue&type=script&lang=js&"
import style0 from "./subdeal.vue?vue&type=style&index=0&id=022d4f2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d4f2c",
  null
  
)

export default component.exports